<np-dialog
    [popupWidth]="1250" [popupHeight]="800" [popupTitle]="'Suchformular editieren / anlegen' | translate"
    [popupVisible]="searchFormPopupVisible"
    (popupVisibleChange)="onSearchFormPopupVisibleChange($event)">
    <div slot="content">
    <np-search-forms
        [initialSearchForm]="initialSearchForm"
    ></np-search-forms>
    </div>
</np-dialog>

<div style="height: 100%;">
  <div class="row" style="height: 100%;">
      <div *ngIf="loginService.hasAddonSearchForm" class="col p-3" style="height: 100%; overflow-y: auto;">
          <searchFormOptions
              [refreshWithSearchForm]="refreshWithSearchForm"
              [syncWithService]="false"
              (onEditSearchForm)="toggleSeachFormPopup($event)"
              (onExecuteSearchForm)="onSearchFormSelected($event)"
          ></searchFormOptions>
      </div>
      <div class="col dx-fieldset p-3">
        <div class="dx-field" *ngIf="isExcel() || this.exportParameter.isUpdateFilter">
          <div class="dx-field-label">{{ 'ExportProducts' | translate }}</div>
          <div class="dx-field-value">
            <dx-select-box [items]="exportProductTypes"
                           [(value)]="selectedExportProductType"
                           (onValueChanged)="onExportProductsChanged($event)"
                           displayExpr="text"></dx-select-box>
          </div>
        </div>
        
        <div class="dx-field" *ngIf="this.exportParameter.isUpdateFilter">
          <div class="dx-field-label">{{ 'Nach Update leere Kategorien löschen' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch [(value)]="exportParameter.deleteEmptyCategoriesAfterUpdate"></dx-switch>
          </div>
        </div>
    
        <div class="dx-field" *ngIf="!isExcel() && !this.exportParameter.isUpdateFilter">
          <div class="dx-field-label">{{ 'Kategorien ohne Produkte nicht exportieren' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch [(value)]="exportParameter.ignoreEmptyCategories"></dx-switch>
          </div>
        </div>
    
        <div class="dx-field">
          <div class="dx-field-label">
            {{ 'Master immer ausgeben, wenn Childs den Filterkriterien entsprechen' | translate }}
          </div>
          <div class="dx-field-value">
            <dx-switch [readOnly]="selectedExportProductType.id != ''"
                       [(value)]="exportParameter.exportMasterOfFilteredChilds"></dx-switch>
          </div>
        </div>
      </div>
  </div>
</div>
